import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const GideonFeatured = () => {
  const { t } = useLanguage();

  return (
    <section className="section-padding bg-gradient-to-br from-gideon-parchment/40 via-white to-gideon-khaki/20">
      <div className="container-max">
        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl border-2 border-gideon-olive/35 bg-white shadow-lg overflow-hidden ring-1 ring-gideon-moss/15">
            <div className="p-8 sm:p-10 md:p-12">
              <div className="flex flex-col md:flex-row md:items-center gap-8">
                <div className="flex-shrink-0">
                  <div className="w-20 h-20 bg-gradient-to-br from-gideon-moss to-gideon-olive rounded-2xl flex items-center justify-center shadow-inner">
                    <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                </div>
                <div className="flex-1">
                  <p className="text-xs uppercase tracking-wider font-semibold text-gideon-moss mb-2">
                    {t('prayerUnits.units.gideonForce.name', 'Gideon Force')}
                  </p>
                  <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
                    {t('gideon.hero.subtitle', 'Mighty Warrior, the Lord is with you')}
                  </h2>
                  <p className="text-gray-600 mb-6">
                    {t('prayerUnits.units.gideonForce.description')}
                  </p>
                  <div className="flex flex-wrap gap-3">
                    <Link
                      to="/gideon-force"
                      className="inline-flex items-center px-6 py-3 bg-prayer-red text-white rounded-xl font-semibold hover:bg-prayer-red-light transition-colors"
                    >
                      {t('gideon.cta.learnMore', 'Learn More')}
                    </Link>
                    <Link
                      to="/gideon-force#enlist"
                      className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-gideon-moss to-gideon-olive text-white rounded-xl font-semibold hover:opacity-95 transition-opacity shadow-md"
                    >
                      {t('gideon.cta.enlistNow', 'Enlist Now')}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GideonFeatured;
